module.exports = __webpack_public_path__ + "images/external_images/img/711x532/img1.jpg";